// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search/SearchBar/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old_PatientSelect_Content_Content_New_ReferralSource_Content_Referrals_Referral_Source_Search_SearchBar_Content(
  $search_term: String!
  $parent_company_id: uuid!
  $is_patient: Boolean!
) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: true
  ) {
    person: vaxiom_person {
      id
      title
      first_name
      middle_name
      last_name
      search_name
      greeting
      gender
      birth_date
      ssn
      profile_pic_url
      public_user {
        id
      }
      patient @include(if: $is_patient) {
        id
        _id
        primary_location {
          id
          name
        }
        human_readable_id
        legacy_id
      }
      other_professional_relationships @skip(if: $is_patient) {
        id
        external_office {
          id
          name
          postal_address {
            id
            city
            state
          }
        }
        employee_type {
          id
          name
        }
      }
    }
  }
}

`